// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1kg4-","horizontalFlip":"Video_horizontalFlip__1s0Zk"};